import React from "react";
import "../styles/NavBarStyle.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowsIcon, HomeIcon } from "../../../assets/svgs";
import MoneyFruit from "../../../assets/svgs/MoneyFruit";
import Bell from "../../../assets/svgs/Bell";
import LogoutIcon from "../../../assets/svgs/LogoutIcon";
import useTailwindBreakpoints from "../../../hooks/useTailwindBreakPoints";
import ToolTip from "../../core/components/ToolTip";
import { logout } from "../../../network/Apiservices";
import axiosInstance from "../../../network/axiosInstance";
import { getThemeColor } from "../../auth/utils/utility";
import { useTheme } from "../../../theme/ThemeProvider";
import Cards from "../../../assets/svgs/Cards";
import Loans from "../../../assets/svgs/Loans";
import Reports from "../../../assets/svgs/Reports";
import MenuDotsIcon from "../../../assets/svgs/MenuDotsIcon";
import ServiceRequestsIcon from "../../../assets/svgs/ServiceRequestsIcon";

interface NavBarProps {}

const NavBar: React.FC<NavBarProps> = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { md, xl, "5xl": fxl } = useTailwindBreakpoints();
  const aub_routes = [
    {
      path: "/dashboard/home",
      icon: HomeIcon,
      name: "Home",
    },
    {
      path: "/dashboard/transaction",
      icon: ArrowsIcon,
      name: "Transactions",
    },
    {
      path: "/dashboard/analytics",
      icon: MoneyFruit,
      name: "Analytics",
    },
    {
      path: "/dashboard/loans",
      icon: Loans,
      name: "Loans",
    },
    {
      path: "/dashboard/cards",
      icon: Cards,
      name: "Cards",
    },

    {
      path: "/dashboard/reports",
      icon: Reports,
      name: "Reports",
    },
    {
      path: "/dashboard/service-requests",
      icon: ServiceRequestsIcon,
      name: "Service Requests",
    },
    {
      path: "/dashboard/more",
      icon: MenuDotsIcon,
      name: "More",
    },
  ];

  const digibank_routes = [
    {
      path: "/dashboard/home",
      icon: HomeIcon,
      name: "Home",
    },
    {
      path: "/dashboard/transaction",
      icon: ArrowsIcon,
      name: "Transactions",
    },
    {
      path: "/dashboard/analytics",
      icon: MoneyFruit,
      name: "Analytics",
    },
  ];

  const notificationAndLogOut = [
    {
      path: "/dashboard/notifications",
      icon: Bell,
      name: "Notifications",
    },
    {
      path: "/",
      icon: LogoutIcon,
      name: "Logout",
    },
  ];

  const handleLogOut = async () => {
    await logout();
    localStorage.setItem("user", "null");
    delete axiosInstance.defaults.headers["Authorization"];
    axiosInstance.defaults.headers["X_EK_SC_SESSION_ID"] = "";
    console.log("logout() - axios headers: ", axiosInstance.defaults.headers);
    navigate("/auth/login");
  };

  console.log(getThemeColor(theme));
  const routesMap = (routes: any[]) =>
    routes.map((route, index) => (
      <ToolTip key={index} message={route.name}>
        <div key={`000${route.path}`}>
          <div className="flex hover:cursor-pointer h-[3.658rem] md:hover:bg-gray-50_06 justify-center items-center ">
            <route.icon
              onClick={() => {
                if (route.path === "/") {
                  handleLogOut();
                }
                navigate(`${route.path}`);
              }}
              width={fxl ? 35 : md ? 28 : 20}
              height={fxl ? 35 : md ? 28 : 20}
              fill={
                location.pathname === `${route.path}`
                  ? getThemeColor(theme)
                  : "white"
              }
            />
          </div>
        </div>
      </ToolTip>
    ));

  return (
    <div
      className={`flex bg-navbar sm:flex-row lg:flex-row xl:flex-col  xl:justify-between items-center xl:w-[5rem] xl:py-[1rem] md:px-[1rem] xl:px-0 5xl:w-[6rem]`}
    >
      <div
        className="flex sm:flex-row w-full
    sm:justify-between xs:justify-between lg:justify-center lg:flex-row xl:flex-col xl:justify-start md:gap-[3rem] xl:gap-[1.875rem] xs:px-5 xl:px-0"
      >
        {theme === "aub" ? routesMap(aub_routes): routesMap(digibank_routes)}
        {!xl && routesMap(notificationAndLogOut)}
      </div>
      {xl && (
        <div
          className="flex sm:flex-row w-full
    sm:justify-between xs:justify-start xs:ml-10 xl:ml-0 lg:flex-row xl:flex-col xl:justify-start xs:gap-[3rem] md:gap-[3rem] xl:gap-[1.875rem]"
        >
          {routesMap(notificationAndLogOut)}
        </div>
      )}
    </div>
  );
};

export default NavBar;
